import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	isThemeManagementOpen: false,
	selectedThemeName: null,
	selectedTheme: {
		isSideNavbarPrimary: false,
	},
};

const themeManagementSlice = createSlice({
	name: "themeManagement",
	initialState,
	reducers: {
		setIsThemeManagementOpen(state, action) {
			state.isThemeManagementOpen = action.payload;
		},
		setSelectedThemeName(state, action) {
			state.selectedThemeName = action.payload;
		},
		setSelectedTheme(state, action) {
			state.selectedTheme = action.payload;
		},
	},
});

export const { setIsThemeManagementOpen, setSelectedThemeName, setSelectedTheme } = themeManagementSlice.actions;

export default themeManagementSlice.reducer;
